import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=7555ca08&"
import script from "./dialog.vue?vue&type=script&lang=ts&"
export * from "./dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports